import React from "react";
import {
  Container,
  Title,
  ImageContainer,
  InnerContainer,
  TextContainer,
} from "./Broadcaster.styled";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";
import { getStaticImg } from "../../../utils/function";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const Broadcaster = ({
  title,
  contents,
  titleClassName = "",
  isInline = false,
}) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;

  const handleClick = (val) => {
    if (val?.content_url) {
      return window.open(val.content_url, "_blank");
    } else return false;
  };

  // Group items for display
  const renderBroadcasterItems = () => {
    // If no contents or empty array, return null
    if (!contents || contents.length === 0) return null;

    // For desktop mode when inline is true, show all items in a single row
    if (!isMobileView && isInline) {
      return (
        <div className="flex justify-center items-center w-full flex-row gap-8">
          {contents.map((value, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderRadius: 24,
                cursor: value?.content_url?.length ? "pointer" : "default",
              }}
              onClick={() => handleClick(value)}
            >
              <ImageContainer
                cursor={value?.content_url?.length ? "pointer" : "default"}
                className="inline-image"
              >
                <img
                  src={imgPath + value?.key_visual}
                  className="lg:w-[301px] w-[200px] object-contain z-20"
                  alt={value.title || "Broadcaster item"}
                />
              </ImageContainer>
            </div>
          ))}
        </div>
      );
    }

    // If only 1 or 2 items, display them in a single row centered
    if (contents.length <= 2) {
      return (
        <div className="flex justify-center items-center w-full flex-wrap gap-4">
          {contents.map((value, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: 24,
                cursor: value?.content_url?.length ? "pointer" : "default",
              }}
              onClick={() => handleClick(value)}
              className="mx-4"
            >
              <ImageContainer
                cursor={value?.content_url?.length ? "pointer" : "default"}
                className={isInline ? "inline-image" : ""}
              >
                <img
                  src={imgPath + value?.key_visual}
                  className="object-contain z-20 lg:w-[357px] w-[200px]"
                  // style={{
                  //   maxHeight: isInline ? "90px" : "auto",
                  // }}
                  alt={value.title || "Broadcaster item"}
                />
              </ImageContainer>
            </div>
          ))}
        </div>
      );
    }

    // For 3 or more items (mobile or when !isInline), display first two in a row, then one centered in second row
    return (
      <div className="flex flex-col w-full">
        {/* First row - 2 items */}
        <div className="flex justify-center items-center w-full mb-6 gap-4">
          {contents.slice(0, 2).map((value, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: 24,
                cursor: value?.content_url?.length ? "pointer" : "default",
              }}
              onClick={() => handleClick(value)}
              className="mx-4"
            >
              <ImageContainer
                cursor={value?.content_url?.length ? "pointer" : "default"}
                className={isInline ? "inline-image" : ""}
              >
                <img
                  src={imgPath + value?.key_visual}
                  className="object-contain z-20 lg:w-auto w-[99px]"
                  style={{
                    maxHeight: isInline ? "90px" : "auto",
                  }}
                  alt={value.title || "Broadcaster item"}
                />
              </ImageContainer>
            </div>
          ))}
        </div>

        {/* Second row - 1 item centered (if there's a third item) */}
        {contents.length > 2 && (
          <div className="flex justify-center items-center w-full">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: 24,
                cursor: contents[2]?.content_url?.length
                  ? "pointer"
                  : "default",
              }}
              onClick={() => handleClick(contents[2])}
            >
              <ImageContainer
                cursor={
                  contents[2]?.content_url?.length ? "pointer" : "default"
                }
                className={isInline ? "inline-image" : ""}
              >
                <img
                  src={imgPath + contents[2]?.key_visual}
                  className="object-contain z-20 lg:w-auto w-[99px]"
                  style={{
                    maxHeight: isInline ? "90px" : "auto",
                  }}
                  alt={contents[2].title || "Broadcaster item"}
                />
              </ImageContainer>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Container className={"mb-10"}>
        {/* Title image is always displayed at the top, never inline */}
        <img
          id="title-img"
          className="mx-auto z-20 lg:max-w-[428px] lg:h-[55px]"
          style={{
            //   height: "55px",
            objectFit: "contain",
            objectPosition: "center",
          }}
          src={getStaticImg("illustration/official-broadcaster-title.png")}
          alt={title || "Broadcaster"}
        />

        {/* Render broadcaster items */}
        {renderBroadcasterItems()}
      </Container>
    </>
  );
};

export default Broadcaster;
